import RateService from "@/services/rating.service";
import router from "@/router";
import {make} from "vuex-pathify";
import moment from "moment";
import Vue from "vue";
import AppService from "@/services/app.service";
import i18n from "@/plugins/i18n";

const state = {
    ratesAgentBySender: [],
    loading: false,
    pagination: {
        page: 1,
        rowsPerPage: 10
    },
    rateAgentFilters: {
        agentEmail: '',
        channel: '',
        from: moment().subtract(6, 'day').format('YYYY-MM-DD'),
        to: moment().format('YYYY-MM-DD')
    },
    rateAgentGroupByTime: [],
    rateAgentOverall: {},
    ratesAgent: [],
    ratingCfg: {
        is_enabled: false,
        action: 0,
        message: "",
        delay_time: 1,
        is_auto_send: false
    }
}
const mutations = {
    ...make.mutations(state),
    loading(state, payload) {
        state.loading = payload
    }
};
const actions = {
    ...make.actions(state),
    listRatesAgent({commit}) {
        const {bot_code, senderId} = router.currentRoute.params
        commit('loading', true)
        return RateService.listRateAgentBySender(bot_code, senderId)
            .then((res) => {
                commit('SET_RATES_AGENT_BY_SENDER', res.data.results)
            })
            .finally(() => {
                commit('loading', false)
            })
    },
    listRateAgentByTime({state, commit}) {
        const botCode = router.currentRoute.params['bot_code']
        const fromIso = moment(state.rateAgentFilters.from).toISOString()
        const toIso = moment(state.rateAgentFilters.to).add(1, 'd').toISOString()
        return RateService.listRateAgentByTime(botCode, state.rateAgentFilters.agentEmail,
            state.rateAgentFilters.channel, fromIso, toIso)
            .then((res)=> {
                commit('SET_RATE_AGENT_GROUP_BY_TIME',res.data)
            })
    },
    listRateAgentOverall({state, commit}) {
        const botCode = router.currentRoute.params['bot_code']
        const fromIso = moment(state.rateAgentFilters.from).toISOString()
        const toIso = moment(state.rateAgentFilters.to).add(1, 'd').toISOString()
        return RateService.listRateAgentOverall(botCode, state.rateAgentFilters.agentEmail,
            state.rateAgentFilters.channel, fromIso, toIso)
            .then((res)=> {
                commit('SET_RATE_AGENT_OVERALL',res.data)
            })
    },
    listRateAgentDetails({state, commit}) {
        const botCode = router.currentRoute.params['bot_code']
        const fromIso = moment(state.rateAgentFilters.from).toISOString()
        const toIso = moment(state.rateAgentFilters.to).add(1, 'd').toISOString()
        commit('loading', true)
        return RateService.listRateAgentDetails(botCode, state.rateAgentFilters.agentEmail,
            state.rateAgentFilters.channel, fromIso, toIso, state.pagination.page, state.pagination.rowsPerPage)
            .then((res)=> {
                Vue.set(state.pagination, 'totalItems', res.data.count)
                commit('SET_RATES_AGENT',res.data.results)
            })
            .finally(()=> {
                commit('loading', false)
            })
    },
    listRateReportsDetails({state, commit}) {
        const botCode = router.currentRoute.params['bot_code']
        const fromIso = moment(state.rateAgentFilters.from).toISOString()
        const toIso = moment(state.rateAgentFilters.to).add(1, 'd').toISOString()
        commit('loading', true)
        return RateService.listRateReportsDetails(botCode, state.rateAgentFilters.agentEmail,
            state.rateAgentFilters.channel, fromIso, toIso)
            .then((res)=> {
                window.location.href = res.data.url
            })
            .finally(()=> {
                commit('loading', false)
            })
    },
    fetchRatingCfg({commit}) {
        const botCode = router.currentRoute.params.botCode ? router.currentRoute.params.botCode : router.currentRoute.params.bot_code
        commit('loading', true)
        RateService.fetchRatingCfg(botCode)
            .then((res) => {
                commit('SET_RATING_CFG', res.data)
            })
            .finally(() => {
                commit('loading', false)
            })
    },
    updateRatingCfg({commit, state}) {
        const botCode = router.currentRoute.params.botCode
        commit('loading', true)
        RateService.updateRatingCfg(botCode, state.ratingCfg)
            .then(() => {
                AppService.toastInfo(i18n.t('success'))
            })
            .catch(() => {
                AppService.toastError(i18n.t('failed'))
            })
            .finally(() => {
                commit('loading', false)
            })
    }
};
const getters = {
    rateAgentTimeLineChartData(state) {
        let labels = []
        let dataOneStar = []
        let dataTwoStar = []
        let dataThreeStar = []
        let dataFourStar = []
        let dataFiveStar = []
        for (let item of state.rateAgentGroupByTime) {
            labels.push(item.day)
            dataOneStar.push(item.oneStar)
            dataTwoStar.push(item.twoStar)
            dataThreeStar.push(item.threeStar)
            dataFourStar.push(item.fourStar)
            dataFiveStar.push(item.fiveStar)
        }
        return {
            labels,
            datasets: [
                {
                    label: 'One Star',
                    backgroundColor: '#f87979',
                    data: dataOneStar
                },
                {
                    label: 'Two Star',
                    backgroundColor: '#3D5B96',
                    data: dataTwoStar
                },
                {
                    label: 'Three Star',
                    backgroundColor: '#1EFFFF',
                    data: dataThreeStar
                },
                {
                    label: 'Four Star',
                    backgroundColor: '#47B5FF',
                    data: dataFourStar
                },
                {
                    label: 'Five Star',
                    backgroundColor: '#DFF6FF',
                    data: dataFiveStar
                }
            ]
        }
    },
    rateAgentOverallChartData(state) {
        return {
            labels: ['One Star', 'Two Star', 'Three Star', 'Four Star', 'Five Star'],
            datasets: [
                {
                    backgroundColor: ['#f87979', '#3D5B96', '#1EFFFF', '#47B5FF', '#DFF6FF'],
                    data: [state.rateAgentOverall.oneStar, state.rateAgentOverall.twoStar,
                        state.rateAgentOverall.threeStar, state.rateAgentOverall.fourStar ,
                        state.rateAgentOverall.fiveStar]
                }
            ]
        }
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
